import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CustomTemplates from '../components/CustomTemplates';
import LegalChatAssistant from '../components/LegalChatAssistant';
import { Shield, ArrowLeft } from 'lucide-react';

const CustomTemplatesPage = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-card border-b border-border px-4 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <Link to="/dashboard" className="flex items-center space-x-2">
              <Shield className="w-8 h-8 text-blue-500" />
              <span className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent font-['Outfit']">
                NotaryOS
              </span>
            </Link>
          </div>
          <div className="flex items-center space-x-4">
            <span className="text-sm text-slate-400">{user?.username || user?.email}</span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-8">
        {/* Back Link */}
        <Link 
          to="/dashboard" 
          className="inline-flex items-center gap-2 text-slate-400 hover:text-white mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al Dashboard
        </Link>

        {/* Custom Templates Component */}
        <CustomTemplates />
      </main>

      {/* Chat Assistant */}
      <LegalChatAssistant />
    </div>
  );
};

export default CustomTemplatesPage;
